import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { Observable } from 'rxjs';



import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';
import { HttpClientService, UtilityService, AdobeAnalyticsService } from 'lib/ng2-sapmp/src/providers';
import { ANALYTICS_CONSTANTS } from 'config';

@Injectable()
export class NotificationService {

  constructor(private http: HttpClient, private httpClientService: HttpClientService,
    private utilityService: UtilityService,
    private adobeAnalyticsService: AdobeAnalyticsService) { }



    getAlerts() {
        const envConfig = this.utilityService.getEnvConfig();
        let url = 'notificationsUrl';
        if (envConfig.useMock) {
         url = 'notificationsUrlMock';
        }
        return this.httpClientService.get(envConfig[url], this.getHeaders())
        .pipe(
       map((res: HttpResponse<any>) => {
      if (sessionStorage.getItem('sapmp_jwtToken') != null) {
        // refreshes token for logged in scenario upon page load
        //this.httpClientService.tokenRefresh(this.utilityService.getEnvConfig().tokenRefresh);
      }
      return res.body; }));
      }
      getHeaders() {
        let headers = new HttpHeaders();
        headers = headers.append('Authorization', sessionStorage.getItem('sapmp_jwtToken'));
        return headers;
      }
  }
